import { render, staticRenderFns } from "./PhotoServiceItem.vue?vue&type=template&id=aaf1395a&scoped=true&"
import script from "./PhotoServiceItem.vue?vue&type=script&lang=js&"
export * from "./PhotoServiceItem.vue?vue&type=script&lang=js&"
import style0 from "./PhotoServiceItem.vue?vue&type=style&index=0&id=aaf1395a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf1395a",
  null
  
)

export default component.exports